import React from "react";
import T from "prop-types";
import { SCRAP } from "MODULES/inventories/constants";
import * as F from "MODULES/shared/components/Forms/FormTypes";

export default function ConditionWarning({
  inventoryCondition,
  condition,
  canClose = true
}) {
  if (inventoryCondition === SCRAP || condition !== SCRAP) {
    return false;
  }
  return (
    <div className="alert alert-warning margin-bottom-none">
      <div className="media">
        {canClose && (
          <div className="media-left">
            <i className="fa fa-lg fa-warning text-warning" />x
          </div>
        )}
        <div className="media-body">
          <strong>Warning!</strong> Changing the condition to Scrap will reduce
          the inventory&#39;s cost to $0.00
        </div>
      </div>
    </div>
  );
}

ConditionWarning.propTypes = {
  inventoryCondition: T.string.isRequired,
  condition: F.formField(F.stringInput).isRequired,
  canClose: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/EditInventory/ConditionWarning.jsx